import { render } from "./page-calendar.vue?vue&type=template&id=71dc4d68&scoped=true"
import script from "./page-calendar.vue?vue&type=script&lang=js"
export * from "./page-calendar.vue?vue&type=script&lang=js"

import "./page-calendar.vue?vue&type=style&index=0&id=71dc4d68&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dc4d68"],['__file',"src/components/calendar/page-calendar/page-calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71dc4d68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71dc4d68', __exports__)) {
    api.reload('71dc4d68', __exports__)
  }
  
  module.hot.accept("./page-calendar.vue?vue&type=template&id=71dc4d68&scoped=true", () => {
    api.rerender('71dc4d68', render)
  })

}


export default __exports__